export default __webpack_public_path__ + "static/media/fuzzy-search.4e3c53bc.png";